<template>
  <pt-counselor-form class="pt-counselor-form__page"></pt-counselor-form>
</template>

<script>
import PtCounselorForm from 'cps/pt-counselor-manage/pt-counselor-form/withData'
export default {
  name: 'pt-counselor-form__view',
  components: {
    'pt-counselor-form': PtCounselorForm
  }
}
</script>
